import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, Send, Contact, DollarSign, Menu } from "lucide-react";

/* Mobile bottom navigation — 4 priority shortcuts + menu opens drawer */
export default function MobileBottomNav({ onMenuClick }) {
  const { pathname } = useLocation();
  const items = [
    { to: "/crm", label: "Home", icon: LayoutDashboard, testid: "mb-home", end: true },
    { to: "/x", label: "Compose", icon: Send, testid: "mb-compose" },
    { to: "/crm/contacts", label: "CRM", icon: Contact, testid: "mb-crm" },
    { to: "/crm/money", label: "Money", icon: DollarSign, testid: "mb-money" },
  ];
  return (
    <nav
      className="lg:hidden fixed bottom-0 inset-x-0 z-30 flex items-stretch"
      style={{
        background: "rgba(255,255,255,0.96)",
        backdropFilter: "blur(20px)",
        borderTop: "1px solid var(--gio-border)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
      data-testid="mobile-bottom-nav"
    >
      {items.map(({ to, label, icon: Icon, testid, end }) => {
        const active = end ? pathname === to : pathname.startsWith(to);
        return (
          <NavLink
            key={to}
            to={to}
            data-testid={testid}
            className="flex-1 flex flex-col items-center justify-center py-2.5 transition"
            style={{ color: active ? "var(--gio-primary)" : "var(--gio-muted-2)" }}
          >
            <Icon size={20} strokeWidth={active ? 2.4 : 2} />
            <span className="text-[10px] font-bold mt-1 tracking-wide">{label}</span>
          </NavLink>
        );
      })}
      <button
        type="button"
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); onMenuClick && onMenuClick(); }}
        data-testid="mb-menu"
        className="flex-1 flex flex-col items-center justify-center py-2.5 transition active:bg-[var(--gio-surface-hi)]"
        style={{ color: "var(--gio-muted-2)", border: 0, background: "transparent" }}
      >
        <Menu size={20} strokeWidth={2} />
        <span className="text-[10px] font-bold mt-1 tracking-wide">More</span>
      </button>
    </nav>
  );
}
